import $ from 'jquery';

const anchorScrolling = () => {

    const $link = $('.js-anchor-link');

    if ($link.length < 1) {
        return;
    }

    $link.on('click', function (event) {
        event.preventDefault();
        const $this = $(this);
        const id = $this.attr('href');
        const $target = $(`${id}`);

        $('html, body').animate({
            scrollTop: $target.offset().top - 30
        }, 500);
    });

};

export default anchorScrolling;
